import { environment } from "@web-src/environments/environment";

export const getAppId = () => environment.firebaseTokenId;
